import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router/index.js'
import less from 'less'
// import moment from 'moment';
  
Vue.use(less)
Vue.use(ElementUI)
// Vue.prototype.$moment = moment

new Vue({
  el: '#app',
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js